<template>
    <section class="container hidden" id="moderne-technologie">
        <div class="technology-section">
            <!-- EMS Airflow Section -->
            <div class="row-custom" id="ems-airflow-technologie">
                <div class="team-col">
                    <h1>EMS Airflow Technologie</h1>
                    <p class="lead-text">
                        Bij Tandzorg Gestel werken wij met <strong>EMS Airflow technologie</strong> volgens het
                        <strong>GBT-protocol (Guided Biofilm Therapy)</strong>. Met deze stapsgewijze methode
                        verwijderen we biofilm, verkleuringen en tandsteen op een comfortabele en minimaal invasieve manier.
                    </p>
                    <p class="benefit-title"><strong>Voordelen van EMS Airflow:</strong></p>
                    <ul class="benefits-list">
                        <li>Behandeling volgens het GBT-protocol</li>
                        <li>Comfortabel en doorgaans zonder hard schrapen</li>
                        <li>Effectieve verwijdering van biofilm, plaque en aanslag</li>
                        <li>Zachter voor tandvlees, glazuur en implantaten</li>
                    </ul>
                </div>
                <div class="team-col image-col-right">
                    <img src="../assets/images/ems.jpg" alt="EMS Airflow technologie voor comfortabele professionele tandreininging" class="tech-image">
                </div>
            </div>

            <!-- Digital Scanner Section -->
            <div class="row-custom reverse" id="digitale-scanner">
                <div class="team-col">
                    <h1>Digitale Scanner: Afdrukken zijn Verleden Tijd</h1>
                    <p class="lead-text">
                        Met onze moderne <strong>digitale scanner</strong> zijn traditionele happen meestal niet meer nodig.
                        In enkele minuten maken we een zeer nauwkeurige 3D-scan van uw gebit, zonder afdruklepel of
                        afdrukpasta in de mond.
                    </p>
                    <p class="benefit-title"><strong>Waarom digitaal scannen beter is:</strong></p>
                    <ul class="benefits-list">
                        <li>Geen onprettige afdrukpasta of kokhalsreflex</li>
                        <li>Zeer nauwkeurige 3D-beelden van uw gebit</li>
                        <li>Sneller en comfortabeler tijdens de behandeling</li>
                        <li>Het resultaat direct zichtbaar op het scherm</li>
                        <li>Betrouwbare pasvorm voor kronen, bruggen en andere voorzieningen</li>
                    </ul>
                </div>
                <div class="team-col image-col-left">
                    <img src="../assets/images/scanner.jpg" alt="Digitale scanner - geen traditionele afdrukken meer nodig" class="tech-image">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "ModerneTechnologie",
    mounted() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if(entry.isIntersecting){
                    entry.target.classList.add('show')
                } 
            })
        })

        const hiddenElements = document.querySelectorAll('.hidden')
        hiddenElements.forEach((el) => observer.observe(el))
    }
}
</script>

<style scoped>
.hidden {
    opacity: 0;
    transform: translateY(100px);
    transition: all 1.5s;
}

.show {
    opacity: 1;
    transform: translateY(0);
}

.technology-section {
    padding: 4rem 0;
}

.team-col {
    flex-basis: 48%;
}

.row-custom {
    margin-bottom: 6rem;
    display: flex;
    align-items: center;
}

.row-custom:last-child {
    margin-bottom: 0;
}

.row-custom.reverse {
    flex-direction: row-reverse;
}

.row-custom .image-col-right, .row-custom .image-col-left {
    display: flex;
    justify-content: center;
    align-items: stretch;
}

.tech-image {
    width: 100%;
    max-width: 600px;
    height: 400px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(0,0,0,0.15);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.tech-image:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 30px rgba(0,0,0,0.2);
}

.team-col h1 {
    color: var(--blue);
    margin-bottom: 1.2rem;
    font-size: 2.4rem;
    line-height: 1.2;
}

.team-col p {
    padding: 0 0 1.5rem 0;
    font-size: 1.4rem;
    line-height: 1.7;
}

.team-col p strong {
    color: var(--blue);
    display: inline;
    margin-bottom: 0;
    font-size: 1.5rem;
}

.lead-text {
    margin-bottom: 0.8rem;
}

.benefit-title {
    margin: 0.2rem 0 0.8rem 0;
    padding-bottom: 0;
}

.benefits-list {
    margin: 0;
    padding-left: 1.8rem;
}

.benefits-list li {
    font-size: 1.4rem;
    line-height: 1.6;
    margin-bottom: 0.35rem;
    color: var(--black);
}

#modern-technology-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.15);
}

@media(max-width: 991px) {
    .row-custom {
        margin-bottom: 4rem;
        flex-direction: column !important;
        text-align: center;
    }
    
    .row-custom.reverse {
        flex-direction: column !important;
    }
    
    .team-col {
        margin-bottom: 2rem;
    }
    
    .team-col h1 {
        font-size: 2.1rem;
        text-align: center;
    }

    .tech-image {
        height: 300px !important;
        max-width: 100%;
    }

    .team-col p {
        padding: 0 0 1rem 0;
        text-align: left;
    }

    .benefits-list {
        text-align: left;
    }
}
</style>
